/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * update infos
 * @export
 * @interface CheckUpdate200Response
 */
export interface CheckUpdate200Response {
    /**
     * 
     */
    status?: CheckUpdate200ResponseStatusEnum;
    /**
     * 
     */
    newestVersion?: string;
    /**
     * 
     */
    path?: string;
}


/**
 * @export
 */
export const CheckUpdate200ResponseStatusEnum = {
    Ok: 'ok',
    UpdateAvailable: 'update_available',
} as const;
export type CheckUpdate200ResponseStatusEnum = typeof CheckUpdate200ResponseStatusEnum[keyof typeof CheckUpdate200ResponseStatusEnum];


/**
 * Check if a given object implements the CheckUpdate200Response interface.
 */
export function instanceOfCheckUpdate200Response(value: object): value is CheckUpdate200Response {
    return true;
}

export function CheckUpdate200ResponseFromJSON(json: any): CheckUpdate200Response {
    return CheckUpdate200ResponseFromJSONTyped(json, false);
}

export function CheckUpdate200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckUpdate200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'newestVersion': json['newestVersion'] == null ? undefined : json['newestVersion'],
        'path': json['path'] == null ? undefined : json['path'],
    };
}

export function CheckUpdate200ResponseToJSON(json: any): CheckUpdate200Response {
    return CheckUpdate200ResponseToJSONTyped(json, false);
}

export function CheckUpdate200ResponseToJSONTyped(value?: CheckUpdate200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'newestVersion': value['newestVersion'],
        'path': value['path'],
    };
}

